import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import SalesPersonDashboard from "./dashboard";
import useAccessLevels from "../../../../hooks/use-access-levels";


const SalesPersonViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Listens to the changes in location.pathname and with each change:
     * if the url is the same as salesPerson.base, then changes it to the salesPerson.dashboard.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.salesPerson.base, exact: true})) {
            if (operatorAccessLevels.packages.sales.salesPerson) {
                history.replace(routes.salesPerson.dashboard);
            } else {
                history.replace(routes.salesPerson.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.sales.salesPerson])

    return (
        <Switch>
            <Route path={routes.salesPerson.base} exact/>
            {
                operatorAccessLevels.packages.sales.salesPerson &&
                <Route path={routes.salesPerson.dashboard} exact>
                    <SalesPersonDashboard/>
                </Route>
            }
            <Redirect to={routes.salesPerson.base.concat(routes.error.serverErrorForSection)}/>
        </Switch>
    );
};

export default SalesPersonViews;
